import React from 'react'
import OverclaimStatusIndicator from '@Components/StatusPills/OverclaimStatusIndicator'
import {
    OVERCLAIM_FILTER_STATUS,
    OverclaimFilterStatus,
} from '@App/helpers/work-entities/utils/overclaim_filter_status_helper'
import { OverclaimFilterCount } from '@Entities/overclaim/overclaim-status-count'
interface StatusSectionProps {
    statusCounts: OverclaimFilterCount
}

const StatusSection = (props: StatusSectionProps) => {
    const { statusCounts } = props

    return (
        <div className="overclaim-status-section">
            {Object.keys(OVERCLAIM_FILTER_STATUS).map((overclaimKey: OverclaimFilterStatus, index: number) => (
                <OverclaimStatusIndicator
                    key={index}
                    overclaimStatus={overclaimKey}
                    count={statusCounts[overclaimKey] ?? 0}
                    withCount
                />
            ))}
        </div>
    )
}

export default StatusSection
